import { render, staticRenderFns } from "./AccessV2.vue?vue&type=template&id=b6a5f0a4&scoped=true"
import script from "./AccessV2.vue?vue&type=script&lang=js"
export * from "./AccessV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a5f0a4",
  null
  
)

export default component.exports